import { defineStore } from 'pinia'

import { useAsyncRequest } from '@/composables/useAsyncRequest'

export const useCheckoutStore = defineStore('checkout', () => {
    const { loading, error, request } = useAsyncRequest()

    const checkoutData = ref({
        countries: [],
        paymentMethods: [],
        riskInsurance: {
            enabled: false,
            selected: false,
            percentage: 0,
            price: 0
        }
    })

    /* ------------------ */
    /* Computed           */
    /* ------------------ */
    const countries = computed(() => checkoutData.value.countries)
    const paymentMethods = computed(() => checkoutData.value.paymentMethods)
    const riskInsurance = computed(() => checkoutData.value.riskInsurance)

    /* ------------------ */
    /* Load checkout      */
    /* ------------------ */
    const loadCheckout = async () => {
        const response = await request('get', '/api/checkout')

        checkoutData.value = {
            countries: response.countries ?? [],
            paymentMethods: response.paymentMethods ?? [],
            riskInsurance: response.riskInsurance ?? {}
        }

        return checkoutData.value
    }

    return {
        checkoutData,
        countries,
        paymentMethods,
        riskInsurance,
        loadCheckout,
        loading,
        error
    }
})
